import './Logo.css';
import * as React from "react";
import {Link} from "react-router-dom";

function Logo() {
  return (
      <Link to={`/`} style={{ textDecoration: "none"}}>
      <div>
        <div className={"logo"}>
            <span className={"dm-serif-text-regular"}>TapPoints</span>
        </div>
        {/*<div className={"logo-motto"}>*/}
        {/*  <span className={"dm-serif-text-regular"}>Time to save and spend</span>*/}
        {/*</div>*/}
      </div>
      </Link>
  );
}

export default Logo;